import { render, staticRenderFns } from "./PendingPopup.vue?vue&type=template&id=5e61705a&"
import script from "./PendingPopup.vue?vue&type=script&lang=js&"
export * from "./PendingPopup.vue?vue&type=script&lang=js&"
import style0 from "./PendingPopup.vue?vue&type=style&index=0&id=5e61705a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports